<div class="emds modal-content">
    <div class="modal-header">
      <span translate>Custom Date Range</span>
    </div>
    <div *ngIf="isSwap">
      <alert type="danger">{{swapMessage}}</alert>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-sm-6">
          <div class="input-group">
            <input type="text" class="form-control"
              #startDateInput
              id="{{baseId}}-startdate"
              name="{{baseId}}-startdatePicker"
              placeholder="Start Date"
              bsDatepicker
              placement="bottom"
              [bsConfig]="bsConfig"
              [dateCustomClasses]="dateCustomClasses"
              [(ngModel)]="startDate"
              #startDatePicker="bsDatepicker"
              [readonly]="false"
              (ngModelChange)="onStartDateChanged()"
              >
            <span class="input-group-btn">
                <button type="button" class="date-btn btn btn-default btn-flush" id="{{baseId}}-datePickerStartDate"
                    (click)="startDatePicker.toggle()">
                    <i class="glyphicon glyphicon-calendar date-icon"></i>
                </button>
            </span>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="input-group">
            <input type="text" class="form-control"
              #endDateInput
              id="{{baseId}}-enddate"
              name="{{baseId}}-enddatePicker"
              placeholder="End Date"
              bsDatepicker
              placement="bottom"
              [bsConfig]="bsConfig"
              [dateCustomClasses]="dateCustomClasses"
              [(ngModel)]="endDate"
              #endDatePicker="bsDatepicker"
              [readonly]="false"
              (ngModelChange)="onEndDateChanged()"
              >
            <span class="input-group-btn">
                <button type="button" class="date-btn btn btn-default btn-flush" id="{{baseId}}-datePickerEndDate"
                    (click)="endDatePicker.toggle()">
                    <i class="glyphicon glyphicon-calendar date-icon"></i>
                </button>
            </span>
        </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="pull-right">
        <button id="{{Id}}-save"
                class="btn btn-primary"
                (click)="close()"
                [disabled]="!canSave()"
                translate>Save</button>
        <button id="{{Id}}-cancel"
                class="btn btn-secondary btn-flush-right"
                (click)="cancel()"
                translate>Cancel</button>
      </div>
    </div>
</div>
